import Snap from 'snapsvg-cjs';
import createTriangle from './create-triangle';

const sectionOffer = () => {
  if (document.querySelectorAll('.js-offer-anim').length) {
    document.querySelectorAll('.js-offer-anim').forEach(element => {
      const s = Snap(element);
      createTriangle(s, 150, 30, 50, 50, 40);
    });
  }
};

export default sectionOffer;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/kerris-select-chisel/src/scripts/modules/section-offer.js